import React from "react";
import { toAbsoluteUrl } from "../_helpers";
export const SplashScreen = ({ text }) => {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className="mr-2 text-muted">{text}</div>
      <div className="spinner spinner-primary mr-10"></div>
    </div>
  );
};

export const LoadingMessageComponent = ({ children }) => {
  return (
    <div className="d-flex align-items-center justify-content-center min-h-200px">
      <div className="bg-white p-6 d-flex flex-column justify-content-center align-items-center rounded overflow-hidden">
        <div>
          <img
            className="max-w-150px opacity-80 mb-2"
            title={"Loading"}
            src={toAbsoluteUrl("/media/logos/logo.png")}
            alt="Loading.."
          />
        </div>
        <span className="spinner spinner-primary spinner-track spinner-center spinner-lg"></span>
        {children}
      </div>
    </div>
  );
};
